import { Box, Flex } from "@chakra-ui/react";
import { DashboardArea } from "./DashboardArea";
import { useUnauthenticatedDashboardTourGuide } from "@hooks/useUnauthenticatedDashboardTourGuide";
import { TourGuide, RestartTourButton } from "@components/tour-guide";
import { DashboardHeader } from "./DashboardHeader";

export const UnauthenticatedDashboard = () => {
  const {
    unauthenticatedDashboardTourGuide,
    courseCardRef,
  } = useUnauthenticatedDashboardTourGuide();

  return (
    <Box width="100%" height="100%" position="relative">
      <Flex direction="column" height="100%" bg="white" padding={"24px 16px"}>
        <Box mb="24px">
          <DashboardHeader />
        </Box>

        <Box flex="1" overflowY="auto">
          <DashboardArea
            noOfCourses={0}
            courseCardRef={courseCardRef}
          />
        </Box>
      </Flex>

      {/* Restart Tour Button */}
      {!unauthenticatedDashboardTourGuide.isActive && (
        <RestartTourButton
          onClick={unauthenticatedDashboardTourGuide.startTour}
          position={{ bottom: "24px", right: "24px" }}
        />
      )}

      {/* Active Tour Guide */}
      {unauthenticatedDashboardTourGuide.isActive &&
        unauthenticatedDashboardTourGuide.currentStepData && (
          <TourGuide
            isActive={unauthenticatedDashboardTourGuide.isActive}
            currentStep={unauthenticatedDashboardTourGuide.currentStepData}
            currentStepIndex={unauthenticatedDashboardTourGuide.currentStep}
            totalSteps={unauthenticatedDashboardTourGuide.totalSteps}
            onNext={unauthenticatedDashboardTourGuide.nextStep}
            onBack={unauthenticatedDashboardTourGuide.previousStep}
            onClose={unauthenticatedDashboardTourGuide.stopTour}
            targetRef={
              unauthenticatedDashboardTourGuide.currentStepData.id === "course-card"
                ? courseCardRef
                : undefined
            }
            targetSelector={
              unauthenticatedDashboardTourGuide.currentStepData.targetSelector
            }
            borderRadius="8px"
          />
        )}
    </Box>
  );
};
